<template>
  <v-app app>
    <v-content id="content">
      <keep-alive :exclude="['Product', 'Cart', 'Orders']">
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </v-content>
    <v-bottom-navigation background-color="primary" dark app height="48px" fixed shift grow>
      <v-btn height="48px" to="/categorias">
        <span>Início</span>
        <v-icon>dashboard</v-icon>
      </v-btn>

      <v-btn height="48px" to="/pesquisar">
        <span>Buscar</span>
        <v-icon>search</v-icon>
      </v-btn>

      <v-btn
        height="48px"
        :to="{
          name: 'cart',
          query: { unix: Date.now().toString() }
        }"
      >
        <span>Carrinho</span>
        <v-icon>shopping_cart</v-icon>
      </v-btn>

      <!-- Remover botão para beach park -->
      <v-btn
        height="48px"
        :to="{
          name: 'myOrders',
          query: { unix: Date.now().toString() }
        }"
      >
        <span>Meus Pedidos</span>
        <v-icon>restaurant</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      transitionName: "slide-left"
    };
  },
  methods: {
    notOnlyDigitalMenu() {
      if (localStorage.getItem("onlyDigitalMenu") != null) {
        return localStorage.getItem("onlyDigitalMenu").toString() !== "true";
      }
      return true;
    }
  }
};
</script>
